<template>
	<transition name="modal">
		<div>
			<div class="modal-mask-composition">
				<div class="modal-wrapper-composition has-scroll">
					<div class="modal-container-composition">
						<div class="modal-header justify-content-start relative" v-if="$slots.header">
							<slot name="header">
								Modal Header
							</slot>
						</div>

						<div class="modal-body" :class="{ 'p-0': full }">
							<slot name="body">
							</slot>
						</div>

						<div class="modal-footer" v-if="!hideFooter">
							<slot name="footer">
								<button class="btn btn-primary" @click="$emit('close')">OK</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'ModalComposition',
	props: {
		size: {
			type: String,
			default: 'small',
		},
		hideFooter: {
			type: Boolean,
			default: false,
		},
		full: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onKeyup(event) {
			if (event.key === 'Escape') {
				this.$emit('close');
			}
		},
	},
	created() {
		document.body.classList.add('modal-open');
		window.addEventListener('keyup', this.onKeyup);
	},
	destroyed() {
		document.body.classList.remove('modal-open');
		window.removeEventListener('keyup', this.onKeyup);
	},
};
</script>

<style lang="scss">
</style>
